import React from 'react'
import { Outlet } from 'react-router-dom'

const MainInvoicesIncoming = () => {
  return (
    <div className='w-full h-full'>
        <Outlet/>
    </div>
  )
}

export default MainInvoicesIncoming